import { z } from 'zod';
import { FromSchema, ZodDate, Country } from '@40seas/entities/common';
import { Address, AddressSchema } from '@40seas/models';
import { AiprizeRelatedPerson, AiprizeRelatedPersonSchema } from './aiprize.related-person.entity';
import { AiprizeBusinessScope, AiprizeBusinessScopeSchema } from './aiprize.business-scope.entity';
import { AiprizeRegistrationRecord, AiprizeRegistrationRecordSchema } from './aiprize.registration-record.entity';
import { AmlInfo, AmlInfoSchema } from '@40seas/entities/identities';
import { AiprizeRelatedCompany, AiprizeRelatedCompanySchema } from './aiprize.related-company.entity';

export const AiprizeCompanyProfileResultSchema = z
    .object({
        addresses: z.array(z.string()).nullish(),
        legalName: z.string().nullish(),
        tin: z.string().nullish(),
        website: z.string().nullish(),
        businessStartDate: ZodDate.optional(),
        businessEntityId: z.string().optional(),
        phoneNumbers: z.array(z.string()).optional(),
        emailAddresses: z.array(z.string()).optional(),
        relatedPersons: z.array(AiprizeRelatedPersonSchema).optional(),
        relatedCompanies: z.array(AiprizeRelatedCompanySchema).optional(),
        businessScope: AiprizeBusinessScopeSchema.optional(),
        registrationRecords: z.array(AiprizeRegistrationRecordSchema).optional(),
        amlInfo: AmlInfoSchema.optional(),
    })
    .strict();

export class AiprizeCompanyProfileResult extends FromSchema(AiprizeCompanyProfileResultSchema) {
    addresses?: string[];
    legalName?: string;
    tin?: string;
    website?: string;
    businessStartDate?: Date;
    businessEntityId?: string; // Entity ID given by the government to the business.
    phoneNumbers?: string[]; // List of phone numbers associated with this business
    emailAddresses?: string[]; // List of email addresses associated with this business
    relatedPersons?: AiprizeRelatedPerson[];
    relatedCompanies?: AiprizeRelatedCompany[];
    businessScope?: AiprizeBusinessScope;
    registrationRecords?: AiprizeRegistrationRecord[];
    amlInfo?: AmlInfo;
}
